module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NL-7a11e8249689b5900dce607b69913e39.png";